<template>
	<div class="sub-header">
		<van-icon name="arrow-left" size="1.5rem" color="#000000" @click="goBack" />
		<SearchFake placeholders="搜本店" :companyId="companyId" />
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const props = defineProps({
	isShare: {
		type: Boolean,
		default: false,
	},
	isShowGoods: {
		type: Boolean,
		default: false,
	},
	companyCode: {
		type: String,
		default: '',
	},
	companyId: {
		type: [String, Number],
		default: '',
	},
	searchProps: {
		type: Object,
		default: () => ({}),
	},
});

const emit = defineEmits(['showGoods']);

const router = useRouter();

// 返回上一页
const goBack = () => {
	router.back();
};

// 切换商品显示（保留但未使用）
const toToggle = () => {
	emit('showGoods', !props.isShowGoods);
};
</script>

<style scoped lang="scss">
.sub-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 50px;
	width: 100%;
	background: #ffffff;
	padding: 8px 12px;
}
</style>
